import {
	ClientEntityType,
	JobDocumentEntityType,
	JobEntityType,
	JobItemEntityType,
	OrganizationEntityType,
	PatientEntityType,
	PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfTitleAndDate } from "./pdf-title-and-date.component";
import { PdfJobInformation } from "./pdf-job-information.component";
import { PdfTemplateType } from "../document-template.types";
import { PaymentSlipDataInput } from "./qr-payment-slip/qr-payment-helpers";
import { PdfJobItemsTable } from "./job-items-table/pdf-job-items-table";
import { CalculateTotalsResult } from "../../lib/utils/calculate";
import { PdfTemplateConfiguration } from "../../context/PdfTemplateConfigurationContext";
import { useCurrencyHierarchy } from "../../lib/utils/region-utils";

export const PdfInvoiceBody: React.FC<{
	title: "Rechnung" | "Quittung" | "Barzahlungsquittung" | "Kartenzahlungsquittung";
	client: ClientEntityType;
	job: JobEntityType;
	jobDocument: JobDocumentEntityType;
	jobItems: JobItemEntityType[];
	patient: PatientEntityType | undefined;
	practitioner: PractitionerEntityType | undefined;
	paymentSlipData: PaymentSlipDataInput;
	organization: OrganizationEntityType;
	jobTotals: CalculateTotalsResult;
	pdfTemplateConfiguration: PdfTemplateConfiguration;
}> = ({
	title,
	client,
	job,
	jobDocument,
	jobItems,
	patient,
	practitioner,
	paymentSlipData,
	organization,
	jobTotals,
	pdfTemplateConfiguration,
}) => {
	const currency = useCurrencyHierarchy(job, client);
	return (
		<div>
			<div
				aria-label="Dokumenteninhalt"
				style={{
					paddingTop: "5mm",
					paddingLeft: "5mm",
					paddingRight: "10mm",
				}}
			>
				<PdfTitleAndDate
					generalConfig={pdfTemplateConfiguration.general}
					title={title}
					date={jobDocument?.date}
				/>
				<div
					aria-label="Zusatzinformationen"
					style={{
						paddingTop: "5mm",
						fontSize: "10pt",
					}}
				>
					<PdfJobInformation
						generalConfig={pdfTemplateConfiguration.general}
						pdfTemplateType={PdfTemplateType.RECHNUNG}
						client={client}
						job={job}
						jobItems={jobItems}
						patient={patient}
						practitioner={practitioner}
						invoiceNumber={paymentSlipData.invoiceNumber}
						pdfTemplateConfiguration={pdfTemplateConfiguration}
					/>
				</div>
				<div
					style={{
						paddingTop: "5mm",
						fontSize: "10pt",
					}}
				>
					{jobItems && job && (
						<PdfJobItemsTable
							pdfTemplateConfiguration={pdfTemplateConfiguration}
							jobTotals={jobTotals}
							jobDocument={jobDocument}
							jobItems={jobItems}
							organization={organization}
							showDrTax={true}
							isMwstEust={job.is_mwst_eust ?? client.is_mwst_eust ?? organization.is_mwst_eust ?? false}
							templateType={PdfTemplateType.RECHNUNG}
							currency={currency}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
